
import { Cascader, Form } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getBorderRadiusValue } from '../../utils/borderRadius';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const CascaderPropsDefaults = {
    label: '',
    name: '',
    placeholder: '',
    options: [],
    multiple: false,
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true,
    disabled: false,
    hiddenOnly: false
};

const StyledCascader = styled(Cascader)`
    & {
        display: block !important;
        width: ${({$inputWidth})=>$inputWidth ? $inputWidth+' !important' : '100% !important'};
        max-width: 100% !important;
        min-width: 0 !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
    }
    .ant-select-selector {
        width: ${({$inputWidth})=>($inputWidth+' !important')};
        border-radius: ${({$inputBorderRadius})=> {
            const value = getBorderRadiusValue($inputBorderRadius);
            return value ? `${value} !important` : '';
        }};
        font-size: ${({$inputFontSize})=>($inputFontSize ? $inputFontSize+'px !important' : '')};
        color: ${({$inputColor})=>($inputColor ? $inputColor+' !important' : '')};
        background-color: ${({$inputBackgroundColor})=>($inputBackgroundColor ? $inputBackgroundColor+' !important' : '')};
        border-color: ${({$inputBorderColor})=>($inputBorderColor ? $inputBorderColor+' !important' : '')};
        border-width: ${({$inputBorderWidth})=>($inputBorderWidth ? $inputBorderWidth+'px !important' : '')};
        padding: ${({$inputPadding})=>($inputPadding ? $inputPadding+' !important' : '')};
        
        overflow: hidden;
    }
    .ant-select-selection-item,
    .ant-select-selection-placeholder,
    .ant-select-selection-search-input {
        font-size: ${({$inputFontSize})=>$inputFontSize ? `${$inputFontSize}px !important` : 'inherit !important'};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 100%;
    }
    .ant-select-selection-wrap {
        min-width: 0;
        overflow: hidden;
    }
    .ant-select-selection-search {
        min-width: 0;
        max-width: 100%;
        overflow: hidden;
    }
`;

export const FormCascader = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var  _n, _o, _p, _q, _r, _s;
    var inputStyle = {
        width: '100%',
        borderRadius: getBorderRadiusValue((_s = style === null || style === void 0 ? void 0 : style.inputBorderRadius) !== null && _s !== void 0 ? _s : undefined),
        fontSize: (_n = style === null || style === void 0 ? void 0 : style?.inputFontSize) !== null && _n !== void 0 ? (isMobile ? _n/1.1 : _n) : undefined,
        color: (_o = style === null || style === void 0 ? void 0 : style.inputColor) !== null && _o !== void 0 ? _o : undefined,
        backgroundColor: (_p = style === null || style === void 0 ? void 0 : style.inputBackgroundColor) !== null && _p !== void 0 ? _p : undefined,
        borderColor: (_q = style === null || style === void 0 ? void 0 : style.inputBorderColor) !== null && _q !== void 0 ? _q : undefined,
        borderWidth: (_r = style === null || style === void 0 ? void 0 : style.inputBorderWidth) !== null && _r !== void 0 ? _r : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.inputPadding, isMobile),
    }
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l, _m, _t;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : CascaderPropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : CascaderPropsDefaults.name;
    var placeholder = (_i = props === null || props === void 0 ? void 0 : props.placeholder) !== null && _i !== void 0 ? _i : CascaderPropsDefaults.placeholder;
    var options = (_j = props === null || props === void 0 ? void 0 : props.options) !== null && _j !== void 0 ? _j : CascaderPropsDefaults.options;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : CascaderPropsDefaults.required;
    var visible = (_l = props === null || props === void 0 ? void 0 : props.visible) !== null && _l !== void 0 ? _l : CascaderPropsDefaults.visible;
    var multiple = (_m = props === null || props === void 0 ? void 0 : props.multiple) !== null && _m !== void 0 ? _m : CascaderPropsDefaults.multiple;
    var disabled = (_t = props === null || props === void 0 ? void 0 : props.disabled) !== null && _t !== void 0 ? _t : CascaderPropsDefaults.disabled;

    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon

    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;

    // const StyledSelect = styled(Select)`
    //     .ant-select-selector {
    //         width: ${inputStyle.width} !important;
    //         border-radius: ${inputStyle.borderRadius ? inputStyle.borderRadius+'px !important' : ''};
    //         font-size: ${inputStyle.fontSize ? inputStyle.fontSize+'px !important' : ''};
    //         color: ${inputStyle.color ? inputStyle.color+' !important' : ''};
    //         background-color: ${inputStyle.backgroundColor ? inputStyle.backgroundColor+' !important' : ''};
    //         border-color: ${inputStyle.borderColor ? inputStyle.borderColor+' !important' : ''};
    //         border-width: ${inputStyle.borderWidth ? inputStyle.borderWidth+'px !important' : ''};
    //         padding: ${inputStyle.padding ? inputStyle.padding+' !important' : ''};
    //     }
    // `;

    const [fieldHidden, setFieldHidden] = useState(false);

    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    useEffect(()=>{
        if(!calVisible && _a?.formRef && !_a?.props?.hiddenOnly) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
        }
    }, [calVisible])
    
    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
    }, [_a?.fieldSource])

    useEffect(()=>{
        //hiddenOnly字段，控制组件的隐藏和只读。hidden时组件渲染但是不显示�?
        if(_a?.props?.hiddenOnly === true) {
            setFieldHidden(true);
        }
        else {
            setFieldHidden(false);
        }
    }, [_a?.props?.hiddenOnly])

    return !calVisible && !fieldHidden ? null : <div style={{...wStyle, ...fieldHidden ? {
        visibility: 'hidden',
        opacity: 0,
        height: 0,
        overflow: 'hidden',
        padding: 0,
        margin: 0,
        border: 0
    } : {}}}>
        <Form.Item
            label={label && label.trim() ? <span style={labelStyle}>{item_layout === 'vertical' && item_colon ? label+": " : label}</span> : undefined}
            name={name}
            className={(!formStyle?.labelAlign && root_formStyle?.labelAlign === 'right') || formStyle?.labelAlign === 'right' ? 
                'ant-form-item-label-right' : ''}
            layout={item_layout}
            colon={item_colon}
            rules={required ? [{ required: true, message: requiredText}] : []}
        >
            <StyledCascader
                $inputWidth={inputStyle.width}
                $inputBorderRadius={inputStyle.borderRadius}
                $inputFontSize={inputStyle.fontSize}
                $inputColor={inputStyle.color}
                $inputBackgroundColor={inputStyle.backgroundColor}
                $inputBorderColor={inputStyle.borderColor}
                $inputBorderWidth={inputStyle.borderWidth}
                $inputPadding={inputStyle.padding}
                placeholder={placeholder}
                options={options}
                multiple={multiple}
                disabled={disabled}
                onChange={(val)=>{
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name]: {
                            value: val,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }}
                // styles={{
                //     root: inputStyle
                // }}
            />
        </Form.Item>
    </div>;
}

